import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { SplitTimeInputUpdateOptions } from '@caslink/common-client';
import { CommandService } from '../../shared/services/command.service';
import { DeviceInputBaseComponent } from '../device-input-base.component';
import {
    CommandOptimizationRenderingService
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

@Component({
    selector: 'dl-seconds-sensor',
    templateUrl: './seconds-sensor-input.component.html',
    styleUrls: ['./seconds-sensor-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondsSensorInputComponent extends DeviceInputBaseComponent {
    public static $name: string = 'secondsSensor';

    constructor(
        protected commandService: CommandService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        super(commandService, commandOptimizationRenderingService, cdr);
    }

    public invokeCommand() {
        this.invokeChangeCommand(this.deviceInput);
    }

    public onUpdate(event: SplitTimeInputUpdateOptions) {
        this.deviceInput.value = event.newValue;
        this.invokeCommand();
    }
}
